import { Breakpoint, useRelodeAppUI } from "@relode/core";
import { Routing } from "@relode/core/domain";
import * as React from "react";

import { ClientPublicJobProvider, useClientPublicJobContext } from "../_infra";
import { ClientPublicJobDetailsDesktop } from "./clientPublicJobDetailsDesktop";
import { ClientPublicJobDetailsMobile } from "./clientPublicJobDetailsMobile";

export const ClientPublicJobDetailsContainer = () => (
    <ClientPublicJobProvider>
        <PublicJobDetailsInnerContainer />
    </ClientPublicJobProvider>
);

const PublicJobDetailsInnerContainer = () => {
    const {
        actions,
        state: {
            data: { token, currentJobId, job },
        },
    } = useClientPublicJobContext();

    const handleSignIn = () => {
        const privateUrl = `/client/clientPublicJobs/${currentJobId}`;
        localStorage.setItem("relode:redirectUrl", privateUrl);
        window.location.href = Routing.Account.SIGNIN + "?appName=client";
    };

    const { ui: appUIState } = useRelodeAppUI();

    React.useEffect(() => {
        if (!job) return;

        appUIState.actions.setPageTitle(job.details.jobName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [job]);

    React.useEffect(() => {
        if (!token) return;

        // // eslint-disable-next-line @typescript-eslint/no-floating-promises
        // actions.marketResearchLoadCompensation(token);

        // // eslint-disable-next-line @typescript-eslint/no-floating-promises
        // actions.marketResearchLoadDemand(token);

        // // eslint-disable-next-line @typescript-eslint/no-floating-promises
        // actions.marketResearchLoadDiversity(token);

        // // eslint-disable-next-line @typescript-eslint/no-floating-promises
        // actions.marketResearchLoadSupply(token);

        // // eslint-disable-next-line @typescript-eslint/no-floating-promises
        // actions.marketResearchLoadSummary(token);
        // // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <>
            <Breakpoint desktop>
                <ClientPublicJobDetailsDesktop onSignIn={handleSignIn} />
            </Breakpoint>
            <Breakpoint mobile>
                <ClientPublicJobDetailsMobile onSignIn={handleSignIn} />
            </Breakpoint>
        </>
    );
};
